import { TableCellProps } from '@servicetitan/design-system';
import { MonolithLink } from '@components/MonolithLink/MonolithLink';

interface LocationNameCellProps extends TableCellProps {
  name?: string | null;
  locationLinkToMonolith?: string;
}

/**
 * Renders a table cell containing the name of a location as a link.
 *
 * @returns The rendered table cell.
 */
// TODO: Link out to the location page
const LocationNameCell = ({
  colSpan,
  className,
  dataItem,
}: LocationNameCellProps) => {
  return (
    <td colSpan={colSpan} className={className}>
      {dataItem.locationLinkToMonolith ? (
        <MonolithLink
          className='c-blue-500-i'
          href={dataItem.locationLinkToMonolith}
          hideLinkOutIcon
        >
          {dataItem.name}
        </MonolithLink>
      ) : (
        <span>{dataItem.name}</span>
      )}
    </td>
  );
};

export default LocationNameCell;
